export const hasValue = (value) =>
    value !== undefined && value != null && parseFloat(value) === NaN
        ? value.trim() !== ""
        : true;

export const isEmpty = (value) => !hasValue(value);
